/* eslint max-len: ["error", 250] */
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import FacebookProvider, { Login } from 'react-facebook'
import constant from '../../../constants'
import facebookImg from '../../../../media/facebook.svg'

export default class Facebook extends Component {
  responseFacebook = (response) => {
    this.props.onLoginResponse(response)
  }

  render() {
    return (
      <FacebookProvider appId={constant.FACEBOOK_APP_ID}>
        <Login scope="email" onResponse={this.responseFacebook}>
          <span
            className="join-with fb cursor-pointer xs-block xs-text-black xs-text-center xs-relative"
          >
            {this.props.buttonText}
            <img alt='Facebook' src={facebookImg} />
          </span>
        </Login>
      </FacebookProvider>
    )
  }
}

Facebook.propTypes = {
  onLoginResponse: PropTypes.func,
  buttonText: PropTypes.string,
}

Facebook.defaultProps = {
  onLoginResponse: PropTypes.func,
  buttonText: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/components/social/facebook/facebook.js